import CategoryCard from "./CategoryCards";

export default function CategorySection() {
  const apartmentFeaturesOptions = [
    "Secure parking",
    "Prepaid electricity & water",
    "Fibre/Wi-Fi ready",
    "Built-in cupboards & modern finishes",
    "24/7 security",
  ];

  const commercialOptions = [
    "Reception & shared facilities",
    "High-speed internet readiness",
    "Secure tenant & visitor parking",
    "Cleaning & maintenance services",
    "Access control systems",
  ];

  const industrialOptions = [
    "Large loading bays & truck access",
    "3-phase power supply",
    "High ceilings for storage/operations",
    "24/7 security with CCTV",
    "Easy access to major transport routes",
  ];

  return (
    <section className="bg-orange-500 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid gap-8 md:grid-cols-2 items-center">
          {/* Left side - Images with floating badges */}
          <div className="relative">
            {/* Main apartment image */}
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="/assets/Interior-img.png"
                alt="Modern apartment interior"
                className="w-full h-99 object-cover"
              />
            </div>
          </div>

          {/* Right side - Content */}
          <div className="text-white m-10">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-3 h-3 bg-white rounded-full"></div>
              <span className="text-sm font-semibold uppercase tracking-wider">
                ALL INCLUSIVE
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
              Amenities You Can Rely On
            </h2>

            <p className="text-lg mb-8 text-orange-100">
              Our properties are designed with convenience and functionality in
              mind. Each rental category comes with amenities tailored to meet
              your needs.
            </p>

            {/* Category cards */}
            <CategoryCard
              number={"01"}
              title={"Apartment Features"}
              options={apartmentFeaturesOptions}
            />

            <CategoryCard
              number={"02"}
              title={"Commercial"}
              options={commercialOptions}
            />

            <CategoryCard
              number={"03"}
              title={"Industrial"}
              options={industrialOptions}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
